import Id from './Id';
import Created from './Created';
import Updated from './Updated';
import StartDate from './StartDate';
import EndDate from './EndDate';
import RateDate from './RateDate';
import CloseReportDeadlineDate from './CloseReportDeadlineDate';
import DiffAccountantDeadlineDate from './DiffAccountantDeadlineDate';
import DiffBlameDeadlineDate from './DiffBlameDeadlineDate';
import CompletionDate from './CompletionDate';
import ReceiptNumber from './ReceiptNumber';
import ReportNumber from './ReportNumber';
import Storage from './Storage';
import ResponsibleUser from './ResponsibleUser';
import StockTool from './StockTool';
import OtherTool from './OtherTool';
import TangibleAssetsTool from './TangibleAssetsTool';
import StrangeBelongingsTool from './StrangeBelongingsTool';

export const labels = {
  Id: 'Id',
  ReportNumber: 'Leltár jegyzőkönyv',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  StartDate: 'Leltározás kezdete',
  EndDate: 'Leltározás befejezése',
  RateDate: 'Leltárak kiértékelése',
  CloseReportDeadlineDate: 'Záró jegyzőkönyv határideje',
  DiffAccountantDeadlineDate: 'Eltérések könyvelésének határideje',
  DiffBlameDeadlineDate: 'Eltérések miatti felelősség megállapítása',
  CompletionDate: 'Kelt',
  ReceiptNumber: 'Bizonylat szám',
  Storage: 'Raktár',
  ResponsibleUser: 'Felelős',
  StockTool: 'Készletek köre',
  OtherTool: 'Egyéb eszközök köre',
  TangibleAssetsTool: 'Tárgyi eszközök köre',
  StrangeBelongingsTool: 'Idegen tulajdon',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReportNumber',
}, {
  value: 'ReceiptNumber',
}, {
  value: 'StartDate',
}, {
  value: 'EndDate',
}, {
  value: 'RateDate',
}, {
  value: 'CloseReportDeadlineDate',
}, {
  value: 'DiffAccountantDeadlineDate',
}, {
  value: 'DiffBlameDeadlineDate',
}, {
  value: 'CompletionDate',
}, {
  value: 'Storage',
}, {
  value: 'ResponsibleUser',
}, {
  value: 'StockTool',
}, {
  value: 'OtherTool',
}, {
  value: 'TangibleAssetsTool',
}, {
  value: 'StrangeBelongingsTool',
}, {
  value: 'Updated',
}, {
  value: 'Created',
},
];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReportNumber',
}, {
  value: 'StartDate',
}, {
  value: 'EndDate',
}, {
  value: 'RateDate',
}, {
  value: 'Storage',
}, {
  value: 'ResponsibleUser',
}, {
  value: 'CloseReportDeadlineDate',
}, {
  value: 'DiffAccountantDeadlineDate',
}, {
  value: 'DiffBlameDeadlineDate',
}, {
  value: 'CompletionDate',
}, {
  value: 'StockTool',
}, {
  value: 'OtherTool',
}, {
  value: 'TangibleAssetsTool',
}, {
  value: 'StrangeBelongingsTool',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'descending'
};

export default {
  StartDate,
  EndDate,
  RateDate,
  CloseReportDeadlineDate,
  DiffAccountantDeadlineDate,
  DiffBlameDeadlineDate,
  CompletionDate,
  ReceiptNumber,
  ReportNumber,
  Updated,
  Created,
  Id,
  Storage,
  ResponsibleUser,
  StockTool,
  OtherTool,
  TangibleAssetsTool,
  StrangeBelongingsTool,
};
